export { default } from './create-insight'
